import { motion, AnimatePresence } from "framer-motion";
import "./SideBar.css";
import useWindowWidth from "../Hooks/useWindow";
const Sidebar = ({
  children,
  setIsFilter,
  heading,
  subHeading,
  IsNotOverLay,
  minWidth,
  paddingTop,
}) => {
  const width = useWindowWidth();
  return (
    <AnimatePresence>
      {
        <motion.div
          className={`${IsNotOverLay ? "overlayNot" : "overlay"}`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          onClick={(e) => {
            setIsFilter(false);
          }}
        >
          <motion.div
            className={` ${IsNotOverLay ? "sidebar-container2" : "sidebar-container"} `}
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
            onClick={(e) => e.stopPropagation()}
            style={minWidth && width > 580 ? { minWidth: minWidth } : {}}
          >
            <div
              className="sidebar bg-white"
              style={paddingTop ? { paddingTop: paddingTop } : {}}
            >
              {/* Header with close button */}
              <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                <h2 className="sidebar-title text-dark m-0 fs-7 fw-semibold">
                  {heading ? heading : "Select Period"}
                </h2>
                <button
                  className="btn-close1"
                  onClick={(e) => {
                    setIsFilter(false);
                  }}
                >
                  <span className="closeText"> X</span>{" "}
                </button>
              </div>
              <h6>{subHeading}</h6>
              {children}
            </div>
          </motion.div>
        </motion.div>
      }
    </AnimatePresence>
  );
};

export default Sidebar;
